import React from 'react';
import FieldString_RenderEditableInlineInput from "../../../string/render/inline-editable/input-editable-inline";
import FormatLinks from "../../../../../gd/utils/link_and_url/links";

export default class FieldUrl_InlineEditableView extends FieldString_RenderEditableInlineInput {

    onOpenUrlClick = () => {
        const url = FormatLinks.addHttps(this.value);
        gd.openInNewWindow(url)
    }

    renderViewMode() {
        let displayValue = this.props.field.getDisplayValue(this.value);
        const showIcon = _.get(this.props.configOptions, 'showIcon', true)

        const classes = Classes(this.props.viewClasses, this.props.className, {
            'ui5-txt-no-accent-default': !displayValue,
            'invalid-value': !this.props.field.isValueValid(this.value)
        })

        if (!displayValue && this.props.field.placeholder) displayValue = this.props.field.placeholder

        const showOpenLink = !!this.value

        return (
            <div className={classes} onClick={this.onClick}>
                {showIcon && _.get(this.props.field.components, 'ValueIcon', false)}
                <div className="view-value">{displayValue}</div>
                {showOpenLink &&
                    <div className="m-l-auto p-l-10">
                        <div className="ui5-ico-14 link i5-open-new-window" onClick={this.onOpenUrlClick} />
                    </div>
                }

            </div>
        )
    }

}
